import darkmodeToggle from './components/dark-mode.js';
import fullscreenSearch from './components/search.js';
import { Core } from '@unseenco/taxi';
import customSelect from './components/custom-select.js';
import { lazyLoad } from 'unlazy';
import FadeTransition from './components/FadeTransition.js';

// Function to re-init all JS components
function updateActiveNav() {
  const currentPath = window.location.pathname;

  document.querySelectorAll('nav a').forEach(link => {
    const linkPath = new URL(link.href).pathname;

    if (linkPath === currentPath) {
      link.setAttribute('aria-current', 'page');
    } else {
      link.removeAttribute('aria-current');
    }
  });
}
function initComponents() {
  updateActiveNav();
  fullscreenSearch();
  customSelect();
  lazyLoad();
  darkmodeToggle();
}

// Initialize Taxi with fade transition
const taxi = new Core({
  transitions: {
    fade: FadeTransition,
    default: FadeTransition  // Set fade as default
  }
});
taxi.setDefaultTransition('fade');

initComponents();

// Re-init after each page transition
taxi.on('NAVIGATE_IN', () => {
  initComponents();

  const main = document.querySelector('main[data-taxi]');
  const newMainClass = main?.getAttribute('class');

  // Reset scroll at navigation level
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 10);
});
